exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".section-skills{background-color:#f4f4f4}.skill-sets{padding-left:auto;padding-right:auto}.steps-box{margin-top:30px;margin-left:10%;width:40%}@media only screen and (max-width:767px){.steps-box:first-child{text-align:center}}.works-step{margin-bottom:50px}.works-step:last-of-type{margin-bottom:20px}@media only screen and (max-width:767px){.works-step{margin-bottom:20px}}.works-step div{color:#2980b9;font-size:150%;height:54px;width:56px;border:2px solid #2980b9;border-radius:50%;display:inline-block;text-align:center;margin-right:25px;float:left;padding:5px}@media only screen and (max-width:767px){.works-step div{height:40px;width:40px;margin-right:15px;padding:4px;font-size:120%}}@media only screen and (max-width:480px){.works-step p{font-size:.8rem}}@media only screen and (max-width:480px){.works-step b{font-size:.9rem}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?{"id":"data-v-81f90ef6","scoped":false,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/sections/Skills.vue
// module id = 49
// module chunks = 0